import Content, {
	ContentType,
} from "@components/CustomTypography/Content/Content"
import NewResponsiveImage, {
	ResponsiveImageProps,
} from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import ButtonSwitcher from "@components/Switchers/ButtonSwitcher/ButtonSwitcher"
import React from "react"

import ButtonContainer, {
	ButtonContainerProps,
} from "../ButtonContainer/ButtonContainer"
import {Size} from "../Typography/Typography"

import styles from "./ImageTextCard.module.scss"

export type ImageTextCardType = {
	className?: string
	buttonClassName?: string
	withCenterBtn?: boolean
	imageProps?: Omit<ResponsiveImageProps, "src" | "alt">
	scale?: {
		width: 4 | 16
		height: 3 | 9
	}
	contentProps: ContentType
	contentContainer?: string
	buttonContainerProps?: Omit<ButtonContainerProps, "children">
	popupTitleSize?: Size
	popupSubtitleSize?: Size
	popupSubtitleFontWeight?: number
}

const ImageTextCard = (props: ImageTextCardType) => {
	const {data, titleProps, contentProps, subtitleProps} = props.contentProps
	return (
		<div className={`${styles.assetContainer} ${props.className}`}>
			{data?.preview && (
				<NewResponsiveImage
					{...data?.preview}
					{...props.imageProps}
					imageClassName={`${styles.image} ${props.imageProps?.imageClassName}`}
					alt={props.contentProps.data?.title ?? data.preview.alt}
				/>
			)}
			<div className={props.contentContainer}>
				<Content
					{...props.contentProps}
					contentProps={{
						size: Size.XS,
						style: {
							marginTop: "2rem",
						},
						...contentProps,
					}}
					subtitleProps={{
						size: Size.S,
						// style: {
						// 	marginTop: "rem",
						// },
						...subtitleProps,
					}}
					titleProps={{
						size: Size.M,
						as: "h3",
						style: {
							marginTop: "2rem",
						},
						...titleProps,
					}}
				/>
				{data?.buttons != null && (
					<ButtonContainer
						className={props.buttonContainerProps?.className}
					>
						<ButtonSwitcher
							buttonsList={data}
							popupSubtitleFontWeight={
								props.popupSubtitleFontWeight
							}
							popupSubtitleSize={props.popupSubtitleSize}
							popupTitleSize={props.popupTitleSize}
						/>
					</ButtonContainer>
				)}
			</div>
		</div>
	)
}

export default ImageTextCard
